import config from "environment";
import { getRequest, postRequest } from "./client";

import {
  GoogleDriveResource,
  AddGoogleDriveFolderContract,
  DriveResource,
  MSDrive,
  GetMSDriveItemsContract,
  MSSite,
  GetConfluenceSpacesPagesContract,
  GetConfluenceSpaceResourcesContract,
  GetConfluenceSpaceItemsContract,
  ConfluenceDriveResource,
} from "winslow-core";
import {
  apiGetGoogleDriveFolderResourcesPayload,
  apiGetMSDriveFolderResourcesWithSubfoldersPayload,
  apiGetSharePointFolderResourcesWithSubfoldersPayload,
} from "./DriveService.types";
const { baseApi } = config;

// get all folders for the users google auth, if not folderId is provided
// it returns the root folder info
export async function apiGetGoogleDriveFolders(
  userId: string,
  folderId?: string,
  driveId?: string
): Promise<GoogleDriveResource[] | null> {
  const fetchURL =
    `${baseApi}/drive/folders/${userId}` +
    (folderId ? `/${folderId}/` : `/undefined/`) +
    (driveId ? `${driveId}` : ``);
  return await getRequest(fetchURL, "API/apiGetGoogleDriveFolders");
}

export async function apiGetGoogleDriveFolderResources(
  payload: apiGetGoogleDriveFolderResourcesPayload
): Promise<DriveResource[]> {
  const fetchURL = `${baseApi}/drive/folder-resources`;
  return await postRequest(
    fetchURL,
    payload,
    "API/apiGetGoogleDriveFolderResources"
  );
}

export async function apiAddGoogleDriveFolder(
  data: AddGoogleDriveFolderContract["Body"]
) {
  const fetchURL = `${baseApi}/drive/add-folder`;
  return await postRequest(fetchURL, data, "API/apiAddGoogleDriveFolder");
}

export async function apiGetMSDrives(
  userId: string
): Promise<MSDrive[] | null> {
  const fetchURL = `${baseApi}/drive/ms/drives/${userId}`;
  return await getRequest(fetchURL, "API/apiGetMSDrives");
}

export async function apiGetGoogleDrives(
  userId: string
): Promise<MSDrive[] | null> {
  const fetchURL = `${baseApi}/drive/drives/${userId}`;
  return await getRequest(fetchURL, "API/apiGetGoogleDrives");
}

export async function apiGetMSDriveFolderResources(
  data: GetMSDriveItemsContract["Body"]
): Promise<DriveResource[]> {
  const fetchURL = `${baseApi}/drive/ms/items`;
  return await postRequest(fetchURL, data, "API/apiGetMSDriveFolderResources");
}

export async function apiGetConfluenceFolderResources(
  data: GetConfluenceSpaceItemsContract["Body"]
): Promise<ConfluenceDriveResource[]> {
  const fetchURL = `${baseApi}/drive/confluence/items`;
  return await postRequest(fetchURL, data, "API/apiGetConfluenceSpaceItems");
}

export async function apiGetConfluenceSpacePages(
  data: GetConfluenceSpacesPagesContract["Body"]
): Promise<DriveResource[]> {
  const fetchURL = `${baseApi}/drive/confluence/pages`;
  return await postRequest(fetchURL, data, "API/apiGetConfluenceSpacePages");
}

export async function apiGetMSDriveFolderResourcesWithSubfolders(
  payload: apiGetMSDriveFolderResourcesWithSubfoldersPayload
): Promise<DriveResource[]> {
  const fetchURL = `${baseApi}/drive/folder-ms-resources`;
  return await postRequest(
    fetchURL,
    payload,
    "API/apiGetMSDriveFolderResourcesWithSubfolders"
  );
}

export async function apiGetSharePointFolderResourcesWithSubfolders(
  payload: apiGetSharePointFolderResourcesWithSubfoldersPayload
): Promise<DriveResource[]> {
  const fetchURL = `${baseApi}/drive/site-ms-resources`;
  return await postRequest(
    fetchURL,
    payload,
    "API/apiGetSharePointFolderResourcesWithSubfolders"
  );
}

export async function apiGetConfluenceFolderResourcesWithSubfolders(
  payload: GetConfluenceSpaceResourcesContract["Body"]
): Promise<DriveResource[]> {
  const fetchURL = `${baseApi}/drive/space-confluence-resources`;
  return await postRequest(
    fetchURL,
    payload,
    "API/apiGetConfluenceFolderResourcesWithSubfolders"
  );
}

export async function apiGetSharePointSites(
  userId: string
): Promise<MSSite[] | null> {
  const fetchURL = `${baseApi}/drive/ms/sites/${userId}`;
  return await getRequest(fetchURL, "API/apiGetSharePointSites");
}

export async function apiGetConfluenceSpaces(
  userId: string
): Promise<any[] | null> {
  const fetchURL = `${baseApi}/drive/confluence/spaces/${userId}`;
  return await getRequest(fetchURL, "API/apiGetConfluenceSites");
}
